import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { StudioDetails } from '../model/types';

export const getStudioDetailsWithImageAPI = async () => {
  const response = await baseAPI.get<StudioDetails>(
    `/studios/location/with-image`,
  );
  return response.data;
};

export const useGetStudioDetailsWithImage = () => {
  return useQuery({
    queryKey: [KEYS.STUDIO_DETAILS],
    queryFn: () => getStudioDetailsWithImageAPI(),
  });
};
